export const PRODUCT_TYPES = {
  DAY_PASS: { 
    id: 0, 
    name: 'Day Pass', 
    plural: 'Day Passes',
    description: 'General pool access typically includes fitness center'
  },
  CABANA: { 
    id: 1, 
    name: 'Cabana', 
    plural: 'Cabanas',
    description: 'Covered sofas include reserved seating for 4-6 guests'
  },
  SPA_PASS: { 
    id: 2, 
    name: 'Spa Pass', 
    plural: 'Spa Passes',
    description: 'General pool access plus spa facilities typically paired with a mini treatment'
  },
  DAYBED: { 
    id: 3, 
    name: 'Daybed', 
    plural: 'Daybeds',
    description: 'Semi-covered bed for 2-4 guests typically includes water, bottle of bubbly and fruit'
  },
  ADDON: { 
    id: 4, 
    name: 'Addon', 
    plural: 'Addons',
    description: 'Additional services and amenities'
  },
  FITNESS_PASS: { 
    id: 5, 
    name: 'Fitness Pass', 
    plural: 'Fitness Passes',
    description: 'Fitness center access and fitness classes'
  },
  EVENTS: { 
    id: 6, 
    name: 'Events', 
    plural: 'Events',
    description: 'General pool access paired with special events & activities'
  },
  BEACH_DAY_PASS: { 
    id: 7, 
    name: 'Beach Day Pass', 
    plural: 'Beach Day Passes',
    description: 'Beach access and amenities'
  },
  POOL_BEACH_DAY_PASS: { 
    id: 8, 
    name: 'Pool and Beach Day Pass', 
    plural: 'Pool and Beach Day Passes',
    description: 'Pool and beach access with combined amenities'
  },
};

export const PRODUCT_TYPES_LIST = Object.values(PRODUCT_TYPES);

export const getProductTypeById = (id) => {
  return PRODUCT_TYPES_LIST.find(type => type.id === Number(id)) || PRODUCT_TYPES.DAY_PASS;
};

export const getProductTypeByName = (name) => {
  return PRODUCT_TYPES_LIST.find(type => 
    type.name.toLowerCase() === name.toLowerCase() || 
    type.plural.toLowerCase() === name.toLowerCase()
  ) || PRODUCT_TYPES.DAY_PASS;
};

export const getProductName = (id, amount = 1) => {
  const productType = getProductTypeById(id);
  return amount > 1 ? productType.plural : productType.name;
};

export const getProductNameByName = (name, amount = 1) => {
  const productType = getProductTypeByName(name);
  return amount > 1 ? productType.plural : productType.name;
};

export const getAllProductNames = () => {
  return PRODUCT_TYPES_LIST.map(type => type.name);
};

export const getAllProductNamesString = () => {
  return getAllProductNames().join(',');
}; 